<template>
    <div style="color: #ffffff">
        <div>
            <p class="ds-digital-bold font-24" style="color: #00FAFE;margin-bottom:0">
                <animated-integer :value="this.totalCount"></animated-integer>
            </p>
            <p class="total-title">{{ $t('总采集点') }}</p>
        </div>
        <div>
            <p  style="color: #00FAFE;margin-bottom:0">
                <span class="ds-digital-bold font-24">
                    <animated-integer :value="this.normalCount"></animated-integer>
                </span>
                <span class="total-unit"> {{ $t('个') }}</span>
                <span class="ds-digital-bold font-24">
                    <animated-integer :value="this.Controlrates"></animated-integer>
                </span>
                <span class="total-unit"> %</span>
            </p>
            <p class="total-title">{{ $t('水质达标率') }}</p>
        </div>
        <div>
            <p  style="color: #00FAFE;margin-bottom:0">
                <span class="ds-digital-bold font-24">
                    <animated-integer :value="this.ExceptionCount"></animated-integer>
                </span>
                <span class="total-unit"> {{ $t('个') }}</span>
                <span class="ds-digital-bold font-24">
                    <animated-integer :value="this.abnormalrate"></animated-integer>
                </span>
                <span class="total-unit"> %</span>
            </p>
            <p class="total-title">{{ $t('异常') }}</p>
        </div>
    </div>
</template>
<script>
import animatedInteger from '@/components/maComponents/animated-integer';
import { getAction,postAction } from '@/api/manage'
export default {
    components: {
        animatedInteger
    },
    data() {
        return{
            url:{
                OnStandardStatistical:"/jeecg-charge/wq/wQDataRecord/queryOnStandardStatistical"
            },
            OnStandardStatistical:[],
            totalCount:0,
            normalCount:0,
            ExceptionCount:0,
            Controlrates:0,  //达标率
            abnormalrate:0, //异常率

        }
    },
    mounted() {
    },
    methods: {
        init() {
            this.resetData()
            this.queryOnStandardStatistical();
        },
        resetData() {
            Object.assign(this.$data,this.$options.data.call(this))
        },
        queryOnStandardStatistical() {
            let params = {}
            postAction(this.url.OnStandardStatistical, params).then((res) => {
            if(res.success){
                this.OnStandardStatistical = res.result[0];
                this.totalCount = Number(this.OnStandardStatistical.totalCount);
                this.normalCount = Number(this.OnStandardStatistical.normalCount);
                if(this.normalCount == 0||this.totalCount==0){
                  this.Controlrates = 0
                }else{
                  this.Controlrates = this.normalCount/this.totalCount*100;
                }
                this.ExceptionCount = Number(this.OnStandardStatistical.ExceptionCount);
                if(this.ExceptionCount == 0||this.totalCount==0){
                  this.abnormalrate = 0
                }else{
                  this.abnormalrate = this.ExceptionCount/this.totalCount*100;
                }
                console.log(this.totalCount);
                console.log(this.OnStandardStatistical);
            }
            }) 
        },
    },
}
</script>
<style scoped>
.total-title{
    color: #019AF3
}
.total-unit{
    color: #019AF3;
    font-size: 12px;
    margin: 0 8px;
}
</style>